import { useLang } from "../lib/i18n";

export const ChapterHeading = ({ number, title, dark }) => {
  const { t } = useLang();
  return (
    <div className="mb-14 md:mb-20">
      <div className={`text-[11px] tracking-mega uppercase mb-4 ${dark ? "text-gold" : "text-green/60"}`} data-testid={`chapter-${number}-label`}>
        {t("chapter")} {number}
      </div>
      <h2 className={`font-display text-4xl sm:text-5xl lg:text-6xl leading-tight ${dark ? "text-cream" : "text-ink"}`}>
        {title}
      </h2>
      <div className="gold-rule mt-8 w-40" />
    </div>
  );
};
